import { createSlice } from '@reduxjs/toolkit'

export const CampaignRightModalIdSlice = createSlice({
  name: 'campaign_id',
  initialState: {
    value: ''
  },
  reducers: {
    updateCampaignId: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateCampaignId } = CampaignRightModalIdSlice.actions

export default CampaignRightModalIdSlice.reducer